import React, {useEffect, useState} from 'react';

import styles from './MobileDeliveryPickup.module.css'
import {Button} from "../../../../../../../ui/General/Button/Button.tsx";
import {Modal} from "../../../../../../../ui/Feedback/Modal/Modal.tsx";
import {ModalTypes} from "../../../../../../../ui/Feedback/Modal/types/ModalTypes.ts";
import {Order} from "../../../../../../../types/Order.interface.ts";
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";

interface Props {
    offer: Order,
}

export const MobileDeliveryPickup: React.FC<Props> = ({offer}) => {
    const [isListDisplayed, setIsListDisplayed] = useState<boolean>(false)
    const [isMapShown, setIsMapShown] = useState(false)

    const workingHours = offer.delivery.point.schedule.split(',');

    useEffect(() => {
        if (isListDisplayed) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };

    }, [isListDisplayed]);

    return (<div className={styles.wrapper}>
        <h4 className={styles.title}>
            Выбранный пункт самовывоза:
        </h4>
        <div>
            <div className={styles.name}>
                Пункт выдачи {offer.delivery.point.townName}
            </div>
            <div className={styles.address}>
                {offer.delivery.point.address}
            </div>
        </div>
        <div className={styles.schedule}>
            {workingHours.map((hours) => {
                return <div>{hours}</div>
            })}
        </div>
        <div className={styles.buttons}>
            <Button type='regular' className={styles.btnChoosePoint} onClick={() => setIsListDisplayed(true)}>
                Выбрать другой
            </Button>
            <Button className={styles.btnOpenMap} type='text' onClick={() => setIsMapShown(!isMapShown)}>
                Открыть карту
            </Button>
        </div>

        {isMapShown && (
            <Modal
                type={ModalTypes.mobile}
                isOpen={isMapShown}
                title={<div>
                    <div>{offer.delivery.point.address}</div>
                    <div>(Пункт выдачи {offer.delivery.point.townName})</div>
                </div>}
                close={() => setIsMapShown(false)}
            >
                {/* здесь должна быть интерактивная карта   */}
                <div className={styles.mapWrapper}>
                    {offer.accessibilityBranches.length ?
                        (<YMaps>
                            <Map
                                defaultState={{
                                    zoom: 14,
                                    controls: [],
                                    center: offer.delivery.point.latitude && offer.delivery.point.longitude ? [offer.delivery.point.latitude, offer.delivery.point.longitude] : [],
                                }}
                                width="100%"
                                height={485}
                            >
                                {offer.accessibilityBranches.map(branch => {
                                    if(!branch.latitude || !branch.longitude) return null;

                                    return  <Placemark
                                        modules={["geoObject.addon.balloon"]}
                                        key={branch.id}
                                        defaultGeometry={[branch.latitude, branch.longitude]}
                                        properties={{
                                            balloonContentBody:`<div><div>Адрес: ${branch.address}</div></div>`
                                        }}
                                    />
                                })}
                            </Map>
                        </YMaps>) : null}
                </div>
            </Modal>
        )}
    </div>);
};
